import { UnitTable } from 'components';
import { Paths, UnitType } from 'constants/index';

const Table = () => {
  return (
    <UnitTable path={Paths.ADMIN_CLIENTS_VIEW} type={UnitType.CLIENT} />
  );};

export default Table;
